<div class="content">
  <div class="comments">
    <div class="comments-content custom-scrollbar-light">
      <comment-item
        *ngFor="let comment of comments"
        [comment]="comment"
      ></comment-item>
    </div>
  </div>
  <div class="comment-input">
    <div class="input">
      <textarea
        (keyup.enter)="createComment()"
        [(ngModel)]="comment"
        matInput
        placeholder="Escribe un comentario..."
      ></textarea>
    </div>
    <div>
      <mat-icon (click)="createComment()">send</mat-icon>
    </div>
  </div>
</div>
